import "./LoaderCard.scss";

const LoaderCard = () => {
  return (
    <div className="web_loader">
      <div className="outer"></div>
      <div className="inner"></div>
    </div>
  );
};
export default LoaderCard;
